import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, LineClamp } from '../../global/commonStyle';

interface Props {
  maxWidth: number;
}

interface FileTypeProps {
  fontSize?: number;
}

const FileBoxMain = styled.div<Props>`
  max-width: ${(props) => props.maxWidth}px;
  width: 100%;
  background-color: var(--background-primary);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  /* margin-top: var(--space-4); */
  a {
    color: var(--text-link);
    text-decoration: none !important;
    word-break: break-all;
    &:hover {
      text-decoration: none;
    }
  }
  ${mobile_xl(css`
    max-width: 100%;
  `)}
`;
const FileBoxContainer = styled.div`
  margin-top: unset;
  padding: var(--space-6);
  ${AlignCenter}
  gap: var(--space-12);
  .file-text {
    white-space: nowrap;
  }
`;

const FileBox = styled.div`
  ${AlignCenter}
  width: 100%;
  gap: var(--space-4);
  margin-top: unset;
`;

const ImageDiv = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  position: relative;
  margin-top: unset;
`;

const FileIconDiv = styled.div`
  margin-top: unset;
  svg {
    margin-top: unset;
  }
`;

const FileType = styled.div<FileTypeProps>`
  display: flex;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-46%, -30%);
  color: var(--text-primary);
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
`;

const FileInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
`;

const FileTitle = styled.h4`
  margin: var(--space-0);
  ${LineClamp(1)}
  white-space: break-spaces;
  word-break: break-all;
  &.h4 {
    ${Typography.body_md_medium};
    color: var(--text-primary);
  }
`;

const FileSize = styled.p`
  margin: var(--space-0);
  // m-t -> 0 important is given as there is a class coming from tiptap with m-t -> 12px
  margin-top: var(--space-0) !important;
  /* increases CSS specificity by repeating the generated class name */
  && {
    ${Typography.body_xs};
  }
  color: var(--text-secondary);
`;

export { FileBoxMain, FileBoxContainer, FileBox, ImageDiv, FileIconDiv, FileType, FileInfo, FileTitle, FileSize };
